/* src/app/sitemap/sitemap.component.scss */
ion-list {
  padding: 10px;
}
ion-item {
  cursor: pointer;
}
/*# sourceMappingURL=sitemap.component.css.map */
